const AUCTION_CLAIM_STATES = {
  LOCKED: "Locked",
  CLAIMABLE: "Claimable",
  CLAIMED: "Claimed",
};

export default AUCTION_CLAIM_STATES;
